import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDino: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDino"><Path d="M16 10.5C8.96912 6.22033 7.17125 9.97708 5.46456 13.5433C4.37972 15.8101 3.33172 18 1 18V20H6V22H10V20H13V22H17V19.1973C18.7934 18.1599 20 16.2208 20 14V6.5L22 5.5V5C22 3.34315 20.6569 2 19 2C17.3431 2 16 3.34315 16 5V10.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDino;
